import { Base, withMountWhenInView } from '@studiometa/js-toolkit';

import ScrollRevealClassNames from './ScrollRevealClassNames.js';
import ScrollRevealTitle from './ScrollRevealTitle.js';

/**
 * ScrollRevealParent class.
 */
export default class ScrollRevealParent extends withMountWhenInView(Base, { threshold: 0.05 }) {
  static config = {
    name: 'ScrollRevealParent',
    components: {
      ScrollRevealClassNames,
      ScrollRevealTitle,
    },
  };

  /**
   * Class mounted.
   * Triggers scroll reveal on children && terminate instance.
   */
  mounted() {
    this.$terminate();
  }
}
